import React from 'react';
import { motion } from 'framer-motion';
export function CaseStudySection() {
  return <section className="w-full bg-brand-bg pt-8 md:pt-10 pb-6 md:pb-8 px-6" data-id="element-120">
      <div className="max-w-5xl mx-auto" data-id="element-121">
        <motion.div className="text-center mb-14 relative" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-122">
          <div className="absolute left-1/2 -translate-x-1/2 top-[20%] w-[800px] h-[600px] bg-[#000000]/[0.05] rounded-full blur-[120px] pointer-events-none" data-id="element-123" />
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-gray-900 leading-tight relative z-10" data-id="element-124">
            ¿Tenés miedo de empezar?
            <br data-id="element-125" />
            Ellos también{' '}
            <span className="text-[#000000]" data-id="element-126">empezaron desde cero</span>
          </h2>
          <p className="text-base md:text-lg text-gray-500" data-id="element-127">
            Más de <span className="text-brand-green font-semibold" data-id="element-128">150</span>{' '}
            alumnos ya aplicaron el sistema y escalaron sus resultados.
          </p>
        </motion.div>

        <motion.div className="bg-brand-card rounded-2xl border border-gray-200 p-6 md:p-10 flex flex-col md:flex-row items-center gap-8 md:gap-12 shadow-sm" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        ease: 'easeOut',
        delay: 0.1
      }} data-id="element-129">
          {/* Screenshot */}
          <div className="w-full md:w-1/2 flex-shrink-0" data-id="element-130">
            <div className="rounded-2xl overflow-hidden border border-gray-200 shadow-md" data-id="element-131">
              <img src="https://cdn.magicpatterns.com/uploads/wfRC6ompko2tTydsSZ6ii4/WhatsApp_Image_2026-03-21_at_22.16.55.jpg" alt="Captura de resultados de Susana" className="w-full h-auto object-cover" data-id="element-132" />
            </div>
          </div>

          {/* Case study info */}
          <div className="flex-1" data-id="element-133">
            <span className="inline-block px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-brand-dark bg-gray-100 border border-gray-200 rounded-full mb-4" data-id="element-134">
              Caso Real
            </span>
            <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-135">Susana</h3>
            <p className="text-lg mb-4" data-id="element-136">
              <span className="text-brand-green font-bold" data-id="element-137">
                Ya factura + de 1.500 USD por día
              </span>
            </p>
            <p className="text-gray-600 leading-relaxed" data-id="element-138">
              "Venía probando de todo sin rumbo y pude{' '}
              <strong className="text-gray-900" data-id="element-139">empezar a hacerlo bien</strong>{' '}
              y{' '}
              <strong className="text-gray-900" data-id="element-140">
                elevar mi tasa de conversión
              </strong>
              ... ¡había que tener fe! 🙏❤️
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}